import React, { useState } from 'react';
import { BringzzButton, BringzzImage, BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzImageCheckbox
} from "@bringzz/components";
import { useLocation } from 'react-router-dom';
import PEACE_IMAGE from 'assets/images/peace.png'
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'react-i18next';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

// TODO: BringzzRadioList should accept multiple selections?
const ConsumerSuccessPage = () => {
    const { backPress } = useNavigation();
    const { user } = useAuth()
    const { navigate } = useNavigation();
    const { t } = useTranslation();

    const [profileImage, setProfileImage] = useState(null)

    return (
        <BringzzPageContainer
            className="bg-white"
            footer={
                <div className='pb-8 px-6'>
                    <div className='pb-2'>
                        <BringzzText tag='h5' className={'font-normal'}>{t('component.auth.consumer.success.footer.registration_complete')}</BringzzText>
                        <BringzzText tag='h5' className={'font-normal'}>
                            {t('component.auth.consumer.success.footer.terms_agreement')} <span className='font-bold underline'>{t('component.auth.consumer.success.footer.terms_of_use')}</span> {t('component.auth.consumer.success.footer.and')} <span className='font-bold underline'>{t('component.auth.consumer.success.footer.privacy_policy')}</span>{t('component.auth.consumer.success.footer.settings_info')}
                        </BringzzText>
                    </div>
                    <BringzzButton
                        size='lg'
                        className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                        onClick={async () => {
                            navigate('/')
                        }}
                    >
                        {t('component.auth.consumer.success.buttons.continue')}
                    </BringzzButton>
                </div>
            }
            authenticated={false}
        >
            <div className='relative flex justify-center bg-magic-lilac/20'>
                <div className='relative bg-white w-full bg-cover bg-center flex flex-col'>
                    {/* Content */}
                    <div className='flex-grow flex flex-col py-8 px-4'>
                        <div className='z-10 flex flex-col '>
                            <div className='pl-2 flex flex-col space-y-6 md:max-w-lg lg:max-w-xl xl:max-w-2xl'>
                                <BringzzText tag='h1' className='text-center pl-2 text-midnight-blue font-bold'>
                                    {t('component.auth.consumer.success.title', { firstName: user.firstName })}
                                </BringzzText>
                                <BringzzText tag="h5" className="font-normal">{t('component.auth.consumer.success.subtitle')}</BringzzText>
                            </div>
                            <div className='mt-12 flex justify-center relative'>
                                {profileImage ? (
                                    <img src={profileImage} alt="Profile" className='rounded-full border-8 border-magic-lilac h-48 w-48' />
                                ) : (
                                    <div className='flex justify-center border-8 border-magic-lilac text-white font-bold text-4xl items-center rounded-full bg-midnight-blue h-48 w-48'>P</div>
                                )}
                                <BringzzImage className='absolute p-16 left-14' src={PEACE_IMAGE}></BringzzImage>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BringzzPageContainer >
    );
};

export default ConsumerSuccessPage;
